import { render, staticRenderFns } from "./PackagePromotions.vue?vue&type=template&id=11672158&"
import script from "./PackagePromotions.vue?vue&type=script&lang=js&"
export * from "./PackagePromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports